<script>
    import AjaxCaller from '../mixins/AjaxCaller';
    export default {
        mixins: [AjaxCaller],
        data() {
            return {
                loaded: false,
                response: null
            }
        },
        created() {
            this.makeCall(this.success, this.failure);
        },
        methods: {
            success(response) {
                this.response = response;
                this.loaded = true;
            },
            failure(error) {
                this.stopProcessing();
                console.log(error);
            }
        },
        render() {
            if (!this.loaded) {
                return this.$scopedSlots.default({
                    loading: true,
                    response: null
                });
            }
            return this.$scopedSlots.default({
                loading: false,
                response: this.response.data
            });
        }
    }
</script>